<template>
  <div>
    <b-navbar toggleable="lg" class="mt-0">
      <b-navbar-brand
        href="#"
        class="d-flex align-items-center justify-content-center"
      >
        <img
          v-b-toggle.sidebar-2
          class="d-lg-none nav-menu-icon-sm"
          src="@/assets/icons/open-menu.svg"
          alt
        />
        <span class="nav-logo-brand-wrap">
          <img
            class="nav-logo nav-logo--white my-0 mx-auto"
            src="@/assets/imgs/logos/hr-logo-white.png"
          />
          <img
            class="nav-logo nav-logo--color my-0 mx-auto d-none"
            src="@/assets/imgs/logos/hr-logo-color.png"
          />
        </span>
        <!-- <img
          class="d-lg-none nav-search-icon-sm"
          src="@/assets/icons/search.svg"
          alt
        /> -->
      </b-navbar-brand>
      <b-row
        class="d-md-none d-sm-none d-none d-xl-flex d-lg-flex nav-wrapper"
        v-if="$route.meta.customerNavTabs"
      >
        <b-col>
          <b-tabs
            class="navbar-tabs tasks-tabs"
            v-model="tabIndex"
            @input="selectActiveTab"
            active-nav-item-class="danger"
            active-tab-class="font-weight-bold text-success"
          >
            <b-tab title="Dedicated"></b-tab>
            <b-tab v-if="!isOwnerUser" title="Handover"></b-tab>
            <b-tab v-if="role === 'admin'" title="Archived"></b-tab>
          </b-tabs>
        </b-col>
      </b-row>

      <b-row class="d-xl-flex d-lg-flex d-none nav-wrapper" style="">
        <b-col>
          <div
            v-if="$route.meta.tasks"
            class="navbar-tabs tasks-tabs tasks-tabs-div-wrapper"
          >
            <div
              v-for="(tabTitle, index) in taskTabs"
              :key="index"
              :class="{ active: tabIndexTasks === index }"
              @click="selectActiveTabTasks(index)"
            >{{ tabTitle }}</div>
            <!-- <b-tab title="Task Dashboard"></b-tab>
            <b-tab title="Handover"></b-tab>
            <b-tab
              :class="[role === 'admin' ? 'd-none' : null]"
              title="Weekly"
            ></b-tab> -->
          </div>
        </b-col>
      </b-row>

      <!-- Right aligned nav items -->
      <!-- <b-navbar-toggle target="nav-collapse"></b-navbar-toggle> -->

      <b-navbar-nav
        class="d-none ml-auto nav-main d-lg-flex d-xl-flex align-items-center"
      >
        <div
          v-if="!isOwnerUser"
          class="d-none nav-icons-container d-lg-flex d-xl-flex justify-content-between"
        >
          <SearchBar/>
          <div class="position-relative nav-icons">
            <b-dropdown
              ref="notificationsDropdown"
              class="notifications-dropdown"
              variant="link"
              :no-caret="true"
              :toggle-class="unreadCount > 0 ? 'unread': ''"
              right
            >
              <template #button-content>
                <b-avatar
                  size="3rem"
                  class="notification-icon-wrapper notification-bell-avatar"
                >
                  <b-icon-bell-fill></b-icon-bell-fill>
                </b-avatar>
                <div class="notification-indicator">{{ unreadCount }}</div>
              </template>
              <div
                class="infinite-container notification-wrapper"
                v-for="(item, index) in notification"
                :key="item.id"
              >
                <div class="notification">
                  <div class="avatar-wrapper mt-2">
                    <b-avatar
                      v-if="item.actor.avatarThumbnail"
                      class="bg--primary"
                      size="3rem"
                      :src="item.actor.avatarThumbnail"
                    ></b-avatar>
                    <b-avatar
                      v-else
                      class="bg--primary"
                      size="3rem"
                      :text="avatarName(item.actor)"
                    >
                    </b-avatar>
                  </div>
                  <div class="content">
                    <div class="text-content mt-2">
                      <p v-html="item.bodyHtml"></p>
                      <div class="time">
                        {{ `${humanizeTime(item.timestamp)} ago` }}
                      </div>
                    </div>
                    <div
                      @click="
                        actionNavigator(item.target.id, item.templateCode, item)
                      "
                      class="respond-wrapper"
                      v-if="item.templateCode === handoverReassigned"
                    >
                      <span
                        >View Task<img
                          src="@/assets/icons/notification_respond.svg"
                      /></span>
                    </div>
                    <div
                      @click="actionNavigator(null, item.templateCode, item)"
                      class="respond-wrapper"
                      v-if="item.templateCode === handoverRequestDeclined"
                    >
                      <span
                        >Reassign<img
                          src="@/assets/icons/notification_respond.svg"
                      /></span>
                    </div>
                    <div
                      @click="actionNavigator(null, item.templateCode, item)"
                      class="respond-wrapper"
                      v-if="item.templateCode === handoverRequestMade"
                    >
                      <span
                        >Respond<img
                          src="@/assets/icons/notification_respond.svg"
                      /></span>
                    </div>
                    <div
                      @click="actionNavigator(item.target.taskId, item.templateCode, item)"
                      class="respond-wrapper"
                      v-if="item.templateCode === notifyTimerRunning"
                    >
                      <span
                        >Respond<img
                          src="@/assets/icons/notification_respond.svg"
                      /></span>
                    </div>
                    <div
                      @click="
                        actionNavigator(item.target.id, item.templateCode, item)
                      "
                      class="respond-wrapper"
                      v-if="item.templateCode === assignedCustomer"
                    >
                      <span
                        >Get Started<img
                          src="@/assets/icons/notification_respond.svg"
                      /></span>
                    </div>
                  </div>
                  <div class="close-wrapper mt-2">
                    <img
                      @click="deleteNotification(item.id, index)"
                      class=""
                      src="@/assets/icons/close_notification.svg"
                      alt
                    />
                  </div>
                </div>
              </div>
              <infinite-loading
                spinner="spiral"
                :identifier="notificationInfiniteId"
                force-use-infinite-wrapper="ul.dropdown-menu"
                @infinite="loadNotifications"
              >
                <!-- <div slot="spinner"><b-spinner style="width: 3rem; height: 3rem;"></b-spinner></div> -->
                <div slot="no-more" style="min-width:250px">
                  <p class="mt-3">No more notifications to load</p>
                </div>
                <div slot="no-results" style="min-width:250px">
                  <p class="mt-3">
                    No more notifications to load
                  </p>
                </div></infinite-loading
              >
            </b-dropdown>
          </div>

          <div class="position-relative nav-icons2 chat-icon-wrapper">
            <div class="chat-icon-container">
              <b-icon-chat-left-fill
                scale="1.5"
                @click="openHeadroomSlack"
                class="cursor-pointer"
              ></b-icon-chat-left-fill>
              <!-- <span
                class="notification-circle position-absolute nav-icon-notif-2"
              ></span> -->
            </div>
          </div>
        </div>
        <b-avatar
          v-if="!navAvatar"
          button
          @click="goToProfileSettings"
          class="nav-avatar cursor-pointer"
          size="3rem"
          :text="userInitials"
        ></b-avatar>
        <b-avatar
          v-else
          button
          @click="goToProfileSettings"
          class="nav-avatar"
          style="cursor: pointer"
          size="3rem"
          :src="navAvatar"
        ></b-avatar>
        <b-button
          @click="openLogoutSummary"
          :disabled="loading"
          id="logout-button"
          class="btn-primary btn-pill logout-btn-nav mr-4 py-3"
        >
          <template v-if="loading">
            <b-spinner variant="light" label="Spinning"></b-spinner>
          </template>
          <template v-else>
            Logout
          </template>
        </b-button>
      </b-navbar-nav>
      <audio src="@/assets/audio/notification.mp3" ref="notificationAudio"></audio>
    </b-navbar>
    <div
      v-if="$route.meta.tasks"
      class="d-xl-none d-lg-none tabs-navbar-responsive"
    >
      <b-row class="mx-0 tabs-navbar-row-responsive ">
        <div
          class="navbar-tabs tasks-tabs-div-wrapper responsive"
        >
          <div
            v-for="(tabTitle, index) in taskTabs"
            :key="index"
            :class="{ active: tabIndexTasks === index }"
            @click="selectActiveTabTasks(index)"
          >
            <div>{{ tabTitle }}</div>
          </div>
        </div>
      </b-row>
    </div>
    <div
      v-if="$route.meta.customerNavTabs"
      class="d-xl-none d-lg-none tabs-navbar-responsive"
    >
      <b-row class="mx-0 tabs-navbar-row-responsive">
        <b-tabs
          class="navbar-tabs"
          v-model="tabIndex"
          @input="selectActiveTab"
          active-nav-item-class="danger"
          active-tab-class="font-weight-bold text-success"
        >
          <b-tab title="Dedicated"></b-tab>
          <b-tab v-if="!isOwnerUser" title="Handover"></b-tab>
          <b-tab v-if="!isOwnerUser" title="Archived"></b-tab>
        </b-tabs>
      </b-row>
    </div>
     <b-modal
      body-class="logout-modal-body"
      hide-header
      hide-footer
      size="md"
      visible
      centered
      v-model="logoutModal.visible"
      no-close-on-esc
      no-close-on-backdrop
    >
      <b-button class="close-button">
        <img
          class="close-icon"
          src="@/assets/icons/close_sidebar.svg"
          alt
          @click="logoutModal.visible = false"
        />
      </b-button>

      <div class="title-row primary-dark font-lg">
        <h1>{{ logoutModal.title }}</h1>
      </div>
      <div class="desc-row font-lg">
        <h3>{{ logoutModal.message }}</h3>
      </div>
      <div class="button-row" v-show="false">
        <b-button class="btn-delete btn-pill">
        </b-button>
      </div>
    </b-modal>
    <b-modal
      body-class="logout-summary-modal-body"
      hide-header
      hide-footer
      size="md"
      centered
      v-model="logoutSummaryModal.visible"
      no-close-on-esc
      no-close-on-backdrop
    >
      <b-button class="close-button">
        <img
          class="close-icon"
          src="@/assets/icons/close_sidebar.svg"
          alt
          @click="logoutSummaryModal.visible = false"
        />
      </b-button>

      <div class="title-row primary-dark font-lg">
        <h1>Review today's timers</h1>
      </div>
      <div v-if="logoutSummaryModal.loading" class="text-center py-4">
        <b-spinner variant="primary" />
      </div>
      <template v-else>
        <div v-if="logoutSummaryModal.tasks.length === 0" class="font-md desc-row">
          No timers were tracked today.
        </div>
        <div v-else class="font-md" style="max-height: 260px; overflow-y: auto">
          <div
            v-for="t in logoutSummaryModal.tasks"
            :key="t.id"
            class="d-flex justify-content-between py-2"
            style="border-bottom: 1px solid #eef2f6"
          >
            <span>{{ t.title }}</span>
            <span class="font-family-medium">{{ t.minutes }}m</span>
          </div>
        </div>
      </template>
      <div class="button-row d-flex justify-content-end mt-3" style="gap: 10px">
        <b-button
          class="btn-pill"
          @click="logoutSummaryModal.visible = false"
        >
          Cancel
        </b-button>
        <b-button
          class="btn-primary btn-pill"
          :disabled="loading"
          @click="confirmLogout"
        >
          <b-spinner v-if="loading" small variant="light"></b-spinner>
          <template v-else>Confirm logout</template>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
// import DropdownItemNew from './DropdownItemNew'
import {
  ASSIGN_ASSISTANT_TO_CUSTOMER,
  HANDOVER_REASSIGNED,
  HANDOVER_REQUEST_DECLINED,
  HANDOVER_REQUEST_MADE,
  NOTIFY_TIMER_RUNNING,
  USER_ROLES
} from "@/utils/constants/index";
// import { notificationNavigator } from "@/utils/utils";
import {
  deleteNotifications,
  getSystemNotifications,
  getUnreadNotificationCount,
  markAllAsRead
} from "@/apis/common";
import moment from "moment";
import LogoutManager from '@/utils/LogoutManager'
import { getCustomerDetails } from "@/apis/customers";
import SearchBar from '@/components/searchbar'
import { isEmpty, isOwner } from '@/utils/utils';
import axios from "@/config/axios";

const taskDashboardComponents = [
  "TaskDashboard",
  "AddTask",
  "ViewTask"
]
const weeklyComponents = [
  'PAWeeklyTasks',
  'AllWeeklyTasks',
  'AddWeeklyTask',
  'ViewWeeklyTask'
]

const getCustomerNameFromMessage = (message) => {
  var el = document.createElement( 'html' )
  el.innerHTML = message
  return el.getElementsByTagName( 'b' )[0].textContent
}

export default {
  name: "Navbar",

  data() {
    return {
      notification: [],
      unreadCount: 0,
      notificationModal: false,
      loading: false,
      logoutModal: {
        title: 'Unable to log out',
        visible :  false,
        message: 'You have task timers running'
      },
      logoutSummaryModal: {
        visible: false,
        loading: false,
        tasks: []
      },
      offset: 0,
      notificationInfiniteId: +new Date(),
      handoverReassigned: HANDOVER_REASSIGNED,
      handoverRequestMade: HANDOVER_REQUEST_MADE,
      handoverRequestDeclined: HANDOVER_REQUEST_DECLINED,
      assignedCustomer: ASSIGN_ASSISTANT_TO_CUSTOMER,
      notifyTimerRunning: NOTIFY_TIMER_RUNNING,
      tabIndex: 0,
      tabIndexTasks: 0,
      userInitials: "",
      roleName: "",
      unreadCountIntervalId: "",
      taskTabs: ["Task Dashboard", "Handover", "Weekly"]
    };
  },
  components: {
    SearchBar
    // DropdownItemNew
  },
  computed: {
    ...mapState("authModule", [
      "role",
      "navAvatar",
      "profileUserId",
      "fullName"
    ]),
    isOwnerUser() {
      return this.role === USER_ROLES.OWNER || isOwner();
    }
  },
  mounted() {
    this.$root.$on("bv::dropdown::show", () => {
      if (this.isOwnerUser) return;
      if (this.unreadCount > 0) {
        markAllAsRead().then(() => {
          this.unreadCount = 0;
        });
      }
      this.reloadNotification();
    });
  },
  created() {
    // Owners have no notifications, so skip the poll entirely rather than
    // hammering an endpoint that now refuses them.
    if (!isOwner()) {
      getUnreadNotificationCount().then(res => {
        this.unreadCount = res.data.unreadCount;
      });
      this.unreadCountIntervalId = setInterval(() => {
        getUnreadNotificationCount().then(res => {
          if (res.data.unreadCount > this.unreadCount) {
            this.playNotificationSound()
            this.popupLatestTimerRunningNotification()
          }
          this.unreadCount = res.data.unreadCount;
        });
      }, 30000);
    }
    this.actionGetUserDetails()
      .then(res => {
        this.roleName = res.role;
        if (this.roleName === "admin") {
          this.taskTabs = ["Task Dashboard", "Handover"];
        }
        this.userInitials = this.fullName.match(/\b(\w)/g).join("");
        
        // initialize realtime logout
        this.logoutManager = new LogoutManager(this)
        this.logoutManager.initializeRealtimeLogout()
      })
      .catch(() => {
        this.actionLogoutUser()
          .then(() => {
            this.$router.push({ name: "Login" });
          })
          .catch(err => {
            console.log(err);
          });
      });
    let { name } = this.$route;
    if (name === "DedicatedCustomers") {
      this.tabIndex = 0;
    } else if (name === "HandoverCustomers") {
      this.tabIndex = 1;
    } else if (name === "PAArchivedCustomers") {
      this.tabIndex = 2;
    }
    
    if (taskDashboardComponents.includes(name)) {
      this.tabIndexTasks = 0;
    } else if (name === "HandoverTasks") {
      this.tabIndexTasks = 1;
    } else if (weeklyComponents.includes(name)) {
      this.tabIndexTasks = 2;
    }
  },
  beforeDestroy() {
    this.logoutManager?.destroy();
  },
  watch: {
    fullName() {
      if (this.fullName) {
        this.userInitials = this.fullName.match(/\b(\w)/g).join("");
      }
    },
    $route(to) {
      if (to.name === "DedicatedCustomers") {
        this.tabIndex = 0;
      } else if (to.name === "HandoverCustomers") {
        this.tabIndex = 1;
      } else if (to.name === "PAArchivedCustomers") {
        this.tabIndex = 2;
      }

      if (taskDashboardComponents.includes(to.name)) {
        this.tabIndexTasks = 0;
      } else if (to.name === "HandoverTasks") {
        this.tabIndexTasks = 1;
      } else if (weeklyComponents.includes(to.name)) {
        this.tabIndexTasks = 2
      }
    }
  },
  methods: {
    showNotifications() {
      if (this.unreadCount > 0) {
        markAllAsRead().then(() => {
          this.unreadCount = 0;
        });
      }
      this.reloadNotification();
    },
    playNotificationSound() {
      this.$refs?.notificationAudio?.play();
    },
    onClickOutside(event) {
      console.log(event);
      this.notificationModal = false;
    },
    // notificationNavigator,
    actionNavigator(id, action, notification) {
      this.$refs.notificationsDropdown.hide();

      if (isEmpty(notification.target.id) || isEmpty(notification.actor.id)) {
        this.$router.push({
          name: '404',
          query: {
            customerName: getCustomerNameFromMessage(notification.bodyHtml)
          }
        })
        return
      }

      if (action === HANDOVER_REASSIGNED) {
        if (
          this.$route.name === "HandoverTasks" &&
          this.$route.params.tab === 0
        ) {
          this.$router.go();
        } else {
          this.$router.push({
            name: "HandoverTasks",
            params: {
              tab: 0
            }
          });
        }
      } else if (action === ASSIGN_ASSISTANT_TO_CUSTOMER) {
        getCustomerDetails(id).then(res => {
          if (res.data.isProfileIntakeSubmitted) {
            this.$router.push({
              name: "CustomerDetails",
              params: {
                profileId: id
              },
              query: {
                tab: 2
              }
            });
          } else {
            this.$router.push({
              name: "ClientIntake",
              params: {
                profileId: id
              }
            });
          }
        });
      } else if (action === HANDOVER_REQUEST_MADE) {
        if (
          this.$route.name === "HandoverTasks" &&
          this.$route.params.tab === 0
        ) {
          this.$router.go();
        } else {
          this.$router.push({
            name: "HandoverTasks",
            params: {
              tab: 0
            }
          });
        }
      } else if (action === HANDOVER_REQUEST_DECLINED) {
        if (
          this.$route.name === "HandoverTasks" &&
          this.$route.params.tab === 1
        ) {
          this.$router.go();
        } else {
          this.$router.push({
            name: "HandoverTasks",
            params: {
              tab: 1
            }
          });
        }
      } else if (action === NOTIFY_TIMER_RUNNING) {
        let taskId = id
        this.$router.push({
          name: 'ViewTask',
          params: {
            id: taskId
          }
        })
      }
    },
    deleteNotification(id, index) {
      deleteNotifications(id).then(() => {
        this.notification.splice(index, 1);
      });
    },
    reloadNotification() {
      this.offset = 0;
      this.notification = [];
      this.notificationInfiniteId += 1;
      this.notificationModal = true;
    },
    popupLatestTimerRunningNotification() {
      getSystemNotifications(0).then(res => {
        const latest = (res.data.results || [])[0];
        if (latest && latest.templateCode === NOTIFY_TIMER_RUNNING) {
          this.$bvToast.toast(latest.bodyHtml || "A timer is still running.", {
            title: "Timer reminder",
            variant: "warning",
            autoHideDelay: 8000,
            toaster: "b-toaster-top-right"
          });
        }
      });
    },
    avatarName(actor) {
      let name = actor.firstName + " " + actor.lastName;
      return name.match(/\b(\w)/g).join("");
    },
    humanizeTime(time) {
      let duration = moment.utc().diff(moment(time), "seconds");
      return moment.duration(duration, "seconds").humanize();
    },
    loadNotifications($state) {
      getSystemNotifications(this.offset).then(res => {
        this.notification = [...this.notification, ...res.data.results];
        this.offset = res.data.offset;
        if (res.data.next === null) {
          $state.complete();
        } else {
          $state.loaded();
        }
      });
    },
    openHeadroomSlack() {
      window.open("https://headroomassistance.slack.com", "_blank");
    },
    openLogoutSummary() {
      this.logoutSummaryModal.visible = true;
      this.logoutSummaryModal.loading = true;
      const today = moment().format("YYYY-MM-DD");
      axios({
        url: "/assistant-task-reports/",
        method: "get",
        params: {
          completed_gte: today,
          completed_lte: today,
          assigned_to: this.profileUserId
        }
      })
        .then(res => {
          const results = res.data.results || res.data || [];
          this.logoutSummaryModal.tasks = results.map(item => ({
            id: item.id,
            title: item.title || "Task",
            minutes: Math.round((item.roundedDuration || item.duration || 0) / 60)
          }));
        })
        .catch(() => {
          this.logoutSummaryModal.tasks = [];
        })
        .finally(() => {
          this.logoutSummaryModal.loading = false;
        });
    },
    confirmLogout() {
      this.loading = true
      this.actionLogoutUser()
        .then(() => {
          this.logoutSummaryModal.visible = false;
          this.$router.push({ name: "Login" });
          clearInterval(this.unreadCountIntervalId);
        })
        .catch(err => {
          if (err.response) {
            this.logoutSummaryModal.visible = false;
            this.logoutModal.message = err.response.data.detail
            this.logoutModal.visible = true
          }
        }).finally(() => {
          this.loading = false
        })
    },
    selectActiveTab() {
      if (this.tabIndex === 0) {
        this.$router.push({ name: "DedicatedCustomers" }).catch(() => {});
      } else if (this.tabIndex === 1) {
        this.$router.push({ name: "HandoverCustomers" }).catch(() => {});
      } else if (this.tabIndex === 2) {
        this.$router.push({ name: "PAArchivedCustomers" }).catch(() => {});
      }
    },
    selectActiveTabTasks(index) {
      if (index === 0) {
        this.$router.push({ name: "TaskDashboard" }).catch(() => {});
      } else if (index === 1) {
        this.$router.push({ name: "HandoverTasks", params: { tab: 0 } }).catch(() => {});
      } else if (index === 2) {
        if (this.roleName === "assistant") {
          this.$router
            .push({
              name: "PAWeeklyTasks",
              params: {
                profileId: this.profileUserId
              }
            })
            .catch(() => {});
        } else if (this.roleName === "admin") {
          this.$router.push({ name: "AllWeeklyTasks" }).catch(() => {});
        }
      }
    },
    goToProfileSettings() {
      this.$router.push({ name: "ProfileSettings" });
    },
    ...mapActions("authModule", ["actionLogoutUser", "actionGetUserDetails"])
  }
};
</script>

<style lang="scss" scoped>
@import "~@/scss/variables/colors.scss";
@import "~@/scss/common/fonts.scss";

$notification-spacing: 10px;
.nav-logo {
  // width: 27.1rem;
  width: 12rem;
}
.nav-menu-icon-sm {
  width: 1.5rem;
  height: 1.5rem;
}
.nav-icons {
  display: flex;
  > img {
    width: 2rem;
    height: 2.3rem;
    flex: 1;
    align-items: center;
  }
  // padding-right: 1.5rem;
  margin-right: 1.2rem;
}
.nav-icons2 {
  display: flex;
  border-radius: 50%;
  padding: 0.6rem 0.75rem;
  color: white;
  > img {
    width: 2rem;
    height: 2.3rem;
    flex: 1;
    align-items: center;
  }
  margin-right: 2rem;
}
.nav-icon-1 {
  fill: $primary-dark;
  stroke: $primary-dark;
  stroke-width: 0.4px;
}
.nav-icon-1,
.nav-icon-2 {
  width: 13px;
  height: 16px;
}
.nav-icon-notif {
  right: 0.8rem;
  bottom: 1.8rem;
}
.nav-icon-notif-2 {
  right: -0.3rem;
  bottom: 1.5rem;
}
.nav-avatar {
  margin-right: 2rem;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}
::v-deep .nav-avatar.b-avatar {
  background-color: transparent !important;
  .b-avatar-text span {
    color: $primary-dark;
  }
}
.nav-icons-container {
  align-items: center;
}
.text-content {
  color: $primary-dark;
  white-space: normal;
  overflow-wrap: break-word;
  .time {
    color: #557d8e;
    opacity: 0.5;
    display: inline;
  }
}
#logout-button {
  // font-size: 22.7px;
  line-height: 0;
  height: 30px;
  background-color: $active !important;
  color: #ffffff !important;
}
.logout-btn,
.logout-btn-nav {
  padding-left: 1.2rem;
  padding-right: 1.2rem;
}
::v-deep li.nav-item > a {
  font-size: 1.6rem;
}
nav {
  display: flex;
  align-items: center;
  padding-bottom: 0;
}
::v-deep .nav-wrapper {
  height: 100%;
  padding-left: 19.5rem;
  .nav-link {
    padding-left: 0;
    padding-right: 0;
  }
  div,
  li,
  a,
  ul {
    height: 100%;
  }
  a {
    display: flex;
    align-items: center;
  }
}
.navbar-nav, .nav-icons-container {
  height: 100%;
}
.notification-indicator {
  border: 1px solid $danger;
  position: absolute;
  top: 3px;
  right: -1px;
  line-height: 0;
  color: $danger;
  border-radius: 999px;
  background: white;
  justify-content: center;
  align-items: center;
  padding: 3px;
}
.notification-indicator {
  transform: scale(0);
  transition: transform 0.5s ease-out;
  min-width: 19px;
  height: 19px;
}
button.unread {
  .notification-indicator {
    display: flex;
    transform: scale(1);
  }
}

::v-deep .tab-content {
  // to prevent this div from hovering over and blocking the breadcrumbs
  display: none;
}
::v-deep .notifications-dropdown {
  > button,
  > button.btn,
  > button.btn-link {
    background: transparent !important;
    background-color: transparent !important;
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;
    line-height: 1;
  }

  .notification-icon-wrapper,
  .notification-bell-avatar.b-avatar,
  .notification-bell-avatar.badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: transparent !important;
    background-color: transparent !important;
    border: none !important;
    box-shadow: none !important;
    color: $primary-dark;

    .b-icon {
      color: $primary-dark;
    }
  }

  > button.unread .notification-icon-wrapper,
  > button.unread .notification-bell-avatar,
  > button.unread .notification-icon-wrapper .b-icon,
  > button.unread .notification-bell-avatar .b-icon {
    color: $primary-dark;
  }
  ul.dropdown-menu {
    overflow-y: auto;
    max-height: 50vh;
    padding: 0;
    border: 1px solid #dcebf4;
  }
  .dropdown-divider {
    // border: 1px solid #DCEBF4;
    border-top-width: 1px;
  }
  .notification-wrapper {
    margin: 0;
    > hr {
      margin: 0;
    }
  }
  .notification {
    display: flex;
    padding: $notification-spacing;
    border-bottom: 1px solid #dcebf4;
    > .avatar-wrapper {
      flex: 1;
      padding-right: $notification-spacing;
      margin: 0;
    }
    > .content {
      flex: 4;
      max-width: 350px;
      min-width: 250px;
      > .text-content {
        white-space: normal;
        overflow-wrap: break-word;
        p {
          margin-bottom: 0;
          font-size: 1.2rem !important;
          line-height: 2rem;
        }
        .time {
          color: #557d8e;
          opacity: 0.5;
          display: inline;
          font-size: 10px;
        }
      }
      > .respond-wrapper {
        // padding-top: $notification-spacing;
        font-weight: bold;
        color: #5ca0fd;
        display: flex;
        align-items: center;
        > span {
          cursor: pointer;
          font-size: 1.2rem !important;
          img {
            margin-left: 5px;
          }
        }
      }
    }
    > .close-wrapper {
      flex: 1;
      margin-top: 2rem;
      padding-left: $notification-spacing;
      > img {
        cursor: pointer;
      }
    }
  }
}
.tasks-tabs-div-wrapper {
  display: flex;
  > div {
    display: flex;
    color: $white;
    margin-right: 3rem;
    font-size: 1.4rem;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    border-bottom: 3px solid $primary;
  }
  > div.active {
    border-bottom: 3px solid $active;
    color: $danger;
  }
}
.tasks-tabs-div-wrapper.responsive {
  width: 100%;
  display: flex;
  >div {
    flex: 1;
    cursor: pointer;
    margin: auto;
    height: 72px;
    justify-content: space-around;
  }
  >div.active {
    border-bottom: none;
    >div {
      border-bottom: 2px solid $danger;
      height: 100%;
      display: flex;
      align-items: center;
    }
  }
}
::v-deep .logout-modal-body,
::v-deep .logout-summary-modal-body {
  // font-size: $font-size-lg;
  padding: 15px;
  > div {
    padding: 10px;
    line-height: normal;
  }
  > .title-row {
    h1 {
      font-size: 2.2rem !important;
      line-height: normal !important;
      font-weight: bold;
    }
  }
  > .desc-row {
    h3 {
      color: $primary-dark;
      opacity: 0.5;
      font-size: 1.8rem !important;
    }
  }
  > .button-row {
    button {
      padding: 8px 15px;
    }
  }
  .close-button {
    right: -28px;
    position: absolute;
    display: flex;
    top: -22px;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;
  }
}
@media screen and (max-width: 991px) {
  nav.navbar .navbar-brand {
    display: flex;
    align-items: center;
    width: 100vw;
    padding: 0 3.5rem;
  }
  .nav-logo {
    height: 2.8rem;
    width: auto;
  }
}
@media screen and (max-width: 320px) {
  nav.navbar .navbar-brand {
    display: flex;
    width: 100vw;
    align-items: center;
    padding: 0 2.5rem;
  }
  .nav-logo {
    height: 2.8rem;
    width: auto;
  }
}
</style>
